var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88197 1.88382C9.34262 0.962512 10.6574 0.962512 11.118 1.88382L18.882 17.4117C19.2975 18.2428 18.6932 19.2207 17.7639 19.2207H2.23607C1.30684 19.2207 0.702471 18.2428 1.11803 17.4117L8.88197 1.88382Z",
    stroke: "#313131",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 11.5,
    width: 5,
    height: 4,
    rx: 0.5,
    stroke: "#313131",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonBoxIcon);
export default __webpack_public_path__ + "static/media/PolygonBoxIcon.a4a58922f4bda628f53861ea6d5bb928.svg";
export { ForwardRef as ReactComponent };